import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { Events } from 'analytics';
import { useContent } from 'hooks';
import { CustomSVG } from 'components';
import { ShareDialog } from 'features/sharing';
import { ReactionType, useAddReactionAnalyticsMutation } from 'api';

const useStyles = makeStyles(theme => ({
  buttonLabel: {
    // fontSize: 14,
    // lineHeight: '18px',
  },
  button: {
    borderRadius: 16,
  },
  hasShared: {
    backgroundColor: theme.palette.grey[600],
  },
}));

const Share: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const content = useContent();
  const { content_id } = content;

  const [open, setOpen] = useState(false);

  const { mutate: addReactionAnalytics } = useAddReactionAnalyticsMutation();

  const buttonClasses = classNames(classes.button, {
    [classes.hasShared]: content.has_requesting_user_shared,
  });

  function onClickButton() {
    handleOpen();

    addReactionAnalytics({
      content_id,
      reaction_type: ReactionType.Share,
    });
  }

  function handleOpen() {
    setOpen(true);

    const searchParams = new URLSearchParams(location.search);
    window?.analytics?.track(Events.ShareInitiated, {
      content_id,
      referral_source: searchParams.get('es_source'),
    });
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <Fragment>
      <Button
        data-testid="post-actions-share"
        variant="contained"
        color="primary"
        className={buttonClasses}
        classes={{ label: classes.buttonLabel }}
        onClick={onClickButton}
        endIcon={<CustomSVG name="share" size={20} />}
      >
        {t('content:share')}
      </Button>
      <ShareDialog onClose={handleClose} open={open} />
    </Fragment>
  );
};

export default Share;
